import React from 'react';
import cx from 'classnames';

import styles from '../StaticContents.module.scss';

const PaymentsAssurancePolicy: React.FC = () => (
	<div className={cx(styles.staticContents, styles.container)}>
		<div className={cx(styles.center, styles.bold, styles['mb-64'])}>
			<h1>MOTORWAY PAY ASSURANCE POLICY</h1>
			<p>Last updated 7 March 2023</p>
		</div>

		<p className={cx(styles['mb-32'])}>
			We want you to buy with confidence when purchasing vehicles using Motorway Payments. That is why we provide
			assurance that when using Motorway Payments the payment will be made correctly and in a timely manner.
		</p>

		<h3 className={cx(styles['mb-16'])}>When is a Dealer covered under the Motorway Payments Assurance Policy?</h3>

		<ul data-indent className={cx(styles['mb-16'])}>
			<li className={cx(styles['mb-16'])}>
				Where funds are sent to a third party that is not the the intended recipient due to:
				<ul data-indent className={styles.withoutMargin}>
					<li className={styles.withoutMargin}>an external security breach of any part of the Motorway platform;</li>
					<li className={styles.withoutMargin}>an internal security breach; or</li>
					<li className={styles.withoutMargin}>
						an error made by the Motorway Payments Team, <br />
						Motorway will make an additional payment of the amount(s) required to complete the sale.
					</li>
				</ul>
			</li>
			<li className={cx(styles['mb-16'])}>
				Where Motorway has sent <strong>less</strong> than the Total Vehicle Price, Motorway will make an additional
				payment of all amount(s) required to complete the sale.
			</li>
			<li className={cx(styles['mb-16'])}>
				Where Motorway has sent <strong>more</strong> than the Total Vehicle Price, Motorway will reimburse you with the
				total amount paid in excess of the Total Vehicle Price.
			</li>
		</ul>

		<p>
			Please note that the Motorway Payments Assurance Policy does not guarantee that payment will always be made if,
			for example, we have been unable to verify the Seller’s details or there is suspected fraud on theDealer or
			Seller’s account. Please review the Motorway Payment Terms for details of when Motorway may refuse to make
			payment.
		</p>

		<h3 className={cx(styles['mb-16'])}>Please note the following:</h3>

		<ul data-indent>
			<li className={cx(styles.withoutMargin)}>
				The Assurance Policy will not apply if you have collected the vehicle prior to completion of the seller document
				verification process. Our document verification process allows us to carry out all of our internal checks prior
				to payment.
			</li>
			<li className={cx(styles.withoutMargin)}>
				We reserve the right to fix any processing errors we discover by debiting or crediting your ModulrAccount.
			</li>
			<li className={cx(styles.withoutMargin)}>
				By using Motorway Payments, you acknowledge and agree that the remedies contained in thisMotorway Payments
				Assurance Policy represent your sole and exclusive remedy in the circumstances described above.
			</li>
			<li className={cx(styles.withoutMargin)}>
				We reserve the right to vary or terminate the Motorway Payments Assurance Policy at our discretion.We shall
				provide all users of Motorway Payments with written notice at the email address provided to us if we intend to
				terminate or if the change to the policy is, in our reasonable view, a substantial change.
			</li>
		</ul>

		<p>
			<strong>
				The information on this page is strictly confidential and should not be copied, redistributed or reproduced in
				who or in part, nor shared with any third party.
			</strong>
		</p>
	</div>
);

export default PaymentsAssurancePolicy;
